// @ts-nocheck

import React from 'react'
import PropTypes from 'prop-types'
import { Glyph } from '../../../LEGACY/Glyph'
import { colors } from '@lmc/common/constants'
import { theme } from '@lmc/ui-kit'

const TableSortIcon = ({ ascending, descending, paddingLeft = 10 }) => (
  <div
    style={{
      ...styles.wrapper,
      paddingLeft,
    }}
  >
    <span
      style={{
        ...styles.triangle,
        color: ascending ? theme.color.status.primary : colors.darkgrey,
      }}
    >
      <Glyph name="triangle-up" size="xs" />
    </span>
    <span
      style={{
        ...styles.triangle,
        color: descending ? theme.color.status.primary : colors.darkgrey,
      }}
    >
      <Glyph name="triangle-down" size="xs" />
    </span>
  </div>
)

const styles = {
  triangle: {
    width: 14,
    height: 6,
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    bottom: 4,
  },
}

TableSortIcon.propTypes = {
  ascending: PropTypes.bool,
  descending: PropTypes.bool,
  paddingLeft: PropTypes.number,
}

export default TableSortIcon
